import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'aristometrix';

  constructor(breakpointObserver: BreakpointObserver, private router: Router) {
    breakpointObserver.observe([
      Breakpoints.Large,
      Breakpoints.XLarge,
      Breakpoints.Tablet,
      Breakpoints.Web
    ]).subscribe(result => {
      if (result.matches) {
      }
      else {
      }
    });
  }

}
